<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <upload
            @updatedSrc="getSrc"
            :preview="tile"
            @updateTitle="getName"
          ></upload>
        </v-col>
        <v-col cols="12">
          <v-text-field
            label="Title"
            v-model.trim="tile.title"
            type="text"
            placeholder="Tile title"
            id="title"
          ></v-text-field>
          <v-select
            :items="dropdownItems"
            label="Type"
            v-model.trim="tile.type"
          ></v-select>
          <v-checkbox v-model="tile.arabic" label="Arabic?"></v-checkbox>
          <v-select
            :items="dropdownCategories"
            label="Category"
            v-model.trim="tile.category"
          ></v-select>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
import { Upload } from "@/components/functionality";

export default {
  name: "AdminTileUpload",
  components: { Upload },
  data() {
    return {
      dropdownItems: ["Word", "Image"],
      dropdownCategories: [
        "Colour",
        "Illustration",
        "Pattern",
        "Photography",
        "Typography",
        "Word",
      ],
      isValid: true,
    };
  },
  props: {
    tile: Object,
  },
  methods: {
    getSrc(val) {
      this.tile.src = val;
    },
    getName(val) {
      this.tile.title = val;
      this.$nextTick(() => {
        this.tile.title = val;
      });
    },
    validateImage(val) {
      this.isValidImage = val;
    },
  },
};
</script>
